import api from "./api";

export type TenantSettings = {
  _id?: string;
  tenantId?: string;
  locale: string;
  timezone: string;
  currency: {
    code: string;
    symbol: string;
    decimalSeparator: string;
    thousandSeparator: string;
  };
  numbering: {
    ticket: { prefix: string; padding: number; next: number };
    invoice: { prefix: string; padding: number; next: number };
    purchase?: { prefix: string; padding: number; next: number };
  };
  branding?: {
    logoLightUrl?: string;
    logoDarkUrl?: string;
    primaryColor?: string;
    secondaryColor?: string;
  };
  templates?: {
    invoiceTemplate?: string;
    ticketTemplate?: string;
  };
};

export async function getTenantSettings(token: string) {
  const res = await api.get("/settings", { headers: { Authorization: `Bearer ${token}` } });
  return res.data as TenantSettings;
}

export async function updateTenantSettings(token: string, payload: Partial<TenantSettings>) {
  const res = await api.put("/settings", payload, { headers: { Authorization: `Bearer ${token}` } });
  return res.data as TenantSettings;
}

export async function uploadLogo(token: string, file: File, variant: 'light' | 'dark') {
  const toBase64 = (f: File) => new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result));
    reader.onerror = reject;
    reader.readAsDataURL(f);
  });
  const data = await toBase64(file);
  const res = await api.post("/settings/upload-logo", { data, filename: file.name, variant }, { headers: { Authorization: `Bearer ${token}` } });
  return res.data as { url: string };
}
